// extracted by mini-css-extract-plugin
module.exports = {"loginSignupHeader":"login_loginSignupHeader__1DuA9","loginForm":"login_loginForm__3rze6","field":"login_field__2_KtX"};